"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOffRecordListRequest = void 0;
var WriteOffRecordListRequest = /** @class */ (function () {
    function WriteOffRecordListRequest() {
    }
    return WriteOffRecordListRequest;
}());
exports.WriteOffRecordListRequest = WriteOffRecordListRequest;
//# sourceMappingURL=writeOffRecordList.request.js.map